<div class="modal-header">
  <h4 class="modal-title">{{ "profile.edit.edit_add_address" | translate }}</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus>
  @if (message) {
    <div class="m-y-10">{{ message }}</div>
  }

  @if (!fenderShopifyAddress) {
    <div class="form-group">
      <small class="text-muted">{{ "profile.edit.title" | translate }}</small>
      <input class="form-control" [(ngModel)]="address.address_type" />
    </div>
  }
  <div class="form-group">
    <small class="text-muted">{{ "profile.edit.address" | translate }}</small>
    <input class="form-control" [(ngModel)]="address.street" />
  </div>
  <div class="form-group">
    <small class="text-muted">{{ "profile.edit.address2" | translate }}</small>
    <input class="form-control" [(ngModel)]="address.street2" />
  </div>
  <div class="form-group">
    <small class="text-muted">{{ "profile.edit.city" | translate }}</small>
    <input class="form-control" [(ngModel)]="address.city" />
  </div>
  <div class="form-group">
    <small class="text-muted">{{ "profile.edit.country" | translate }}</small>
    <select class="form-control" [(ngModel)]="address.countryCode">
      @for (country of countries; track country) {
        <option [ngValue]="country.code">{{ country.title }}</option>
      }
    </select>
  </div>
  <div class="form-group">
    <small class="text-muted">{{ "profile.edit.state" | translate }}</small>
    @if (address.countryCode != "US") {
      <input class="form-control" [(ngModel)]="address.state" />
    }
    @if (address.countryCode == "US") {
      <select class="form-control" [(ngModel)]="address.state">
        @for (state of states; track state) {
          <option [ngValue]="state.code">{{ state.title }}</option>
        }
      </select>
    }
  </div>
  <div class="form-group">
    <small class="text-muted">{{ "profile.edit.zip" | translate }}</small>
    <input class="form-control" [(ngModel)]="address.zipcode" />
  </div>
  <div class="form-group">
    <small class="text-muted">{{ "profile.edit.phone" | translate }}</small>
    <input class="form-control" [(ngModel)]="address.address_phone" />
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="saveAddress()">{{ "general.save" | translate }}</button>
  <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
</div>
